import { render, staticRenderFns } from "./AssetLinkControl.vue?vue&type=template&id=1e272abf&lang=pug"
import script from "./AssetLinkControl.vue?vue&type=script&lang=js"
export * from "./AssetLinkControl.vue?vue&type=script&lang=js"
import style0 from "./AssetLinkControl.vue?vue&type=style&index=0&id=1e272abf&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports